import { Box, Typography } from '@thirdspacelearning/library';
import { SessionDoneDecoration } from '@assets/dashboard';

const SessionNextLessonNotAvailable = () => (
    <Box
        width="100%"
        display="flex"
        flexGrow={1}
        alignItems="center"
        justifyContent="space-between"
        pl={4}
    >
        <Box>
            <Typography
                variant="h5"
                fontWeight="bold"
                data-testid="completedProgrammeText"
            >
                You've completed your programme!
            </Typography>
            <Typography variant="h6" data-testid="completedProgrammeAltText">
                Please ask your teacher to select the next one for you.
            </Typography>
        </Box>

        <Box display="flex" overflow="hidden" height="110px">
            <SessionDoneDecoration />
        </Box>
    </Box>
);

export default SessionNextLessonNotAvailable;
